import * as Yup from "yup";

export function initialValues(item) {
  return {
    title: item?.title || "",
    description: item?.description || "",
    projectAction: item?.projectAction || null,
    environmentalFactor: item?.environmentalFactor || null,
    sign: item?.sign || "Negativo (−)",
    IN: item?.IN || null,
    EX: item?.EX || null,
    MO: item?.MO || null,
    PE: item?.PE || null,
    RV: item?.RV || null,
    SI: item?.SI || null,
    AC: item?.AC || null,
    EF: item?.EF || null,
    PR: item?.PR || null,
    MC: item?.MC || null,
    controls: item?.controls || "",
    action: item?.action || "",
  };
}

const CRITERIA_IDS = ["IN", "EX", "MO", "PE", "RV", "SI", "AC", "EF", "PR", "MC"];

export function validationSchema(t) {
  const shape = {
    title: Yup.string().required(t("required_field")),
    projectAction: Yup.string().required(t("required_field")),
    environmentalFactor: Yup.string().required(t("required_field")),
    sign: Yup.string().required(t("required_field")),
  };
  CRITERIA_IDS.forEach((id) => {
    shape[id] = Yup.number().required(t("required_field"));
  });
  return Yup.object(shape);
}
